exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".text-bold {\n  font-style: normal !important;\n  font-weight: 600 !important;\n  font-size: 14px !important;\n  line-height: 17px !important; }\n\n.ant-modal-title {\n  color: black;\n  font-size: 18px; }\n", ""]);

